import React, { useState } from "react";

export default function ForgotPassword({ onClose }) {

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const form = new FormData();
            form.append("email", email);
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/auth/forgot-password`,
                {
                    method: "POST",
                    body: form
                }
            );

            const data = await response.json();
            if (!response.ok) {
                setError(data.error || "Impossible d'envoyer le lien");
            } else {
                setMessage("Lien envoyé avec succès")
            }
        } catch (err) {
            setError("Erreur serveur");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginModalOverlay">
            <div className="loginModal">
                <button className="loginModalClose" onClick={onClose}>×</button>


                {
                    !message && (<>
                        <h2>Mot de passe oublié</h2>
                        <p>Indiquez votre mail, un lien de réinitialisation vous sera envoyé vous permettant de modifier votre mot de passe</p>
                        <form onSubmit={handleSubmit}>
                            {/* Email */}
                            <div className="loginModal-input-form">
                                <label>Email</label>
                                <input
                                    type="email"
                                    value={email}
                                    placeholder="Entrez votre email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>


                            {/* Erreur */}
                            {error && <div className="loginModalError">{error}</div>}

                            {/* Bouton submit */}
                            <div className="loginModal-input-form">
                                <button className="loginSubmitBtn" type="submit" disabled={loading}>
                                    {loading ? "Envoi en cours" : "Envoyer"}
                                </button>
                            </div>
                        </form></>
                    )
                }
                {
                    message && (
                        <>
                            <h2>Lien de réinitialisation envoyé</h2>
                            <p>Vous pouvez dès à présent consulter votre boite mail et cliquer sur le lien afin de réinitialiser votre mot de passe</p>
                            <button className="btn-primary" onClick={onClose}>OK</button>
                        </>
                    )
                }

            </div>
        </div>
    );
}
